<template>
  <div class="app_cla">
    <div v-if="isShowInitPage">
      <div class="app-head-cla">
        <div class="app-number-cla" style="display:flex">
          <el-form :model="params" style="display:flex">
            <el-form-item>
              <el-select
                v-model="params.type"
                style="width: 120px"
                :placeholder="$t('developer.selectType')"
                :clearable="true"
                @clear="loadAppList"
              >
                <el-option
                  v-for="item in optionsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" style="margin-left:10px;">
              <el-input
                v-model="params.condition"
                :placeholder="$t('common.inputKeyWord')"
                clearable
                @clear="loadAppList"
              >
                <template slot="append">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click.stop="loadAppList"
                  ></el-button>
                </template> </el-input
            ></el-form-item>
          </el-form>
          <ZkKvItem :label="$t('developer.appNumber')"
            ><span style="color:#78bc27;">{{ appCount }}</span></ZkKvItem
          >
        </div>
        <zk-button-group
          @createAppEvent="addAppEvent"
          groupName="appManager-button"
          style="display:inline-block"
        ></zk-button-group>
      </div>

      <appItem
        v-if="appCount"
        :appList="appList"
        @enterApp="enterApp"
        @deleteApp="deleteApp"
        :endPoint="endPoint"
      ></appItem>
      <zkNoData v-else></zkNoData>
    </div>

    <div v-else style="padding:80px;text-align:center">
      <p class="font_color">{{ $t('developer.noApp') }}</p>
      <span @click="addAppEvent" style="color:#78bc27;cursor: pointer;">
        {{ $t('developer.immCreate') }}
      </span>
    </div>

    <!-- 添加应用 -->
    <appInfoDailog
      ref="appInfoDailog"
      :title="title"
      :appForm="{}"
      :endPoint="endPoint"
      @enterApp="enterApp"
    ></appInfoDailog>
  </div>
</template>
<script>
import { getAppList, deleteApp } from '@/services/appManagerApi.js'
import { mapActions } from 'vuex'
import { getByType } from '@/cdpBase/services/dictionary.js'
import appInfoDailog from './appSetting/appInfo'
import appItem from './appList/itemCard'

export default {
  components: {
    appItem,
    appInfoDailog
  },
  data() {
    return {
      appList: [],
      appInfo: [],
      deleteDia: false,
      isAddSuccess: false,
      endPoint: '',
      title: '',
      params: {
        condition: '',
        type: ''
      },
      optionsList: [
        {
          label: '应用名称',
          value: 0,
          attr: 'name'
        },
        {
          label: 'appKey',
          value: 1,
          attr: 'appKey'
        }
      ]
    }
  },
  mounted() {
    this.loadAppList()
    this.getEndPoint()
  },
  computed: {
    appCount() {
      return this.appList.length
    },
    isShowInitPage() {
      return this.appList.length || this.params.type || this.params.condition
    }
  },

  methods: {
    ...mapActions(['setAppKey']),
    getEndPoint() {
      getByType('endPoint').then(data => {
        this.endPoint = data.results.results[0].value
      })
    },

    enterApp(row) {
      if (sessionStorage.getItem('role') === '"developer"') {
        // 头部显示
        this.setAppKey(row.appKey)
        this.$root.appKey = row.appKey
      }
      this.setAppKey(row.appKey)
      sessionStorage.removeItem('companyId')
      this.$router.push({
        path: '/appSetting/appSetting',
        query: { appId: row.id, endPoint: this.endPoint }
      })
    },
    addAppEvent() {
      this.title = this.$t('developer.addApp')
      this.$refs.appInfoDailog.showDailog()
    },
    deleteApp(row) {
      this.$confirm(
        this.$t('developer.deleteTips'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          deleteApp({
            id: row.id
          })
            .then(data => {
              if (data.code === '00000000') {
                this.successMessage(this.$t('common.successDelete'))
                this.loadAppList()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },

    loadAppList(selectId) {
      let params = {
        condition: this.params.condition
      }
      if (this.params.type) {
        this.optionsList.filter(item => {
          if (item.value === this.params.type) {
            params.type = item.attr
          }
        })
      }
      this.showLoad()
      getAppList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.appList = data.payload.results.dbsAppInfoList
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => this.closeLoad())
    }
  }
}
</script>
<style lang="less" scoped>
.app_cla {
  padding: 20px;
  background: #fff;
  .app-head-cla {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    // margin-bottom: 13px;
  }
  /deep/ .kv_item_cla label {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appList.vue